<template>
  <div>
    <ul class="menu-nav enhanced-sidebar" v-if="$store.state.auth.isAuthenticated && $store.state.auth.normal && !isAgentUser">
      <button ref="hiddenButton" @click="enableAudio" style="display: none;">Enable Audio</button>

      <router-link to="/dashboard" v-slot="{ href, navigate, isActive, isExactActive }">
        <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-menu-item tw-rounded-xl" :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]">
          <a :href="href" class="menu-link enhanced-menu-link tw-flex tw-items-center tw-gap-3 tw-rounded-xl tw-px-3 tw-py-2.5 tw-no-underline" @click="navigate">
            <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-view-dashboard-outline"></i>
            <span class="menu-text">Dashboard</span>
          </a>
        </li>
      </router-link>

      <template v-if="hasPermission('view orders')">
        <li class="menu-section enhanced-section tw-flex tw-items-center tw-justify-between">
          <h4 class="menu-text">Orders</h4>
        </li>
        <router-link to="/orders/today" v-slot="{ href, navigate, isActive, isExactActive }">
          <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-menu-item tw-rounded-xl" :class="[
            isActive && 'menu-item-active',
            isExactActive && 'menu-item-active',
          ]">
            <a :href="href" class="menu-link enhanced-menu-link tw-flex tw-items-center tw-gap-3 tw-rounded-xl tw-px-3 tw-py-2.5 tw-no-underline" @click="navigate">
              <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-calendar-today"></i>
              <span class="menu-text">Today Orders</span>
              <span v-if="navCounts.today" class="gmf-nav-badge gmf-nav-badge--blue">{{ navCounts.today }}</span>
            </a>
          </li>
        </router-link>
        <router-link to="/orders/upcoming" v-slot="{ href, navigate, isActive, isExactActive }">
          <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-menu-item tw-rounded-xl" :class="[
            isActive && 'menu-item-active',
            isExactActive && 'menu-item-active',
          ]">
            <a :href="href" class="menu-link enhanced-menu-link tw-flex tw-items-center tw-gap-3 tw-rounded-xl tw-px-3 tw-py-2.5 tw-no-underline" @click="navigate">
              <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-calendar-week"></i>
              <span class="menu-text">Upcoming days Orders</span>
              <span v-if="navCounts.upcoming" class="gmf-nav-badge gmf-nav-badge--purple">{{ navCounts.upcoming }}</span>
            </a>
          </li>
        </router-link>
        <router-link to="/orders/history" v-slot="{ href, navigate, isActive, isExactActive }">
          <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-menu-item tw-rounded-xl" :class="[
            isActive && 'menu-item-active',
            isExactActive && 'menu-item-active',
          ]">
            <a :href="href" class="menu-link enhanced-menu-link tw-flex tw-items-center tw-gap-3 tw-rounded-xl tw-px-3 tw-py-2.5 tw-no-underline" @click="navigate">
              <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-history"></i>
              <span class="menu-text">Orders History</span>
            </a>
          </li>
        </router-link>
      </template>

      <template v-if="hasPermission('view reservations')">
        <li class="menu-section enhanced-section tw-flex tw-items-center tw-justify-between">
          <h4 class="menu-text">Reservations</h4>
        </li>
        <router-link to="/business/reservations" v-slot="{ href, navigate, isActive, isExactActive }">
          <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-menu-item tw-rounded-xl" :class="[
            isActive && 'menu-item-active',
            isExactActive && 'menu-item-active',
          ]">
            <a :href="href" class="menu-link enhanced-menu-link tw-flex tw-items-center tw-gap-3 tw-rounded-xl tw-px-3 tw-py-2.5 tw-no-underline" @click="navigate">
              <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-table"></i>
              <span class="menu-text">Table Booking</span>
              <span v-if="navCounts.tables" class="gmf-nav-badge gmf-nav-badge--green">{{ navCounts.tables }}</span>
            </a>
          </li>
        </router-link>
        <router-link
          v-if="isRoomReservationsEnabled"
          to="/business/room-reservations"
          v-slot="{ href, navigate, isActive, isExactActive }"
        >
          <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-menu-item tw-rounded-xl premium-menu-item" :class="[
            isActive && 'menu-item-active',
            isExactActive && 'menu-item-active',
          ]">
            <a
              :href="href"
              class="menu-link enhanced-menu-link tw-flex tw-items-center tw-gap-3 tw-rounded-xl tw-px-3 tw-py-2.5 tw-no-underline"
              @click="navigate"
            >
              <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-hotel"></i>
              <span class="menu-text">Room Reservations</span>
              <span v-if="navCounts.rooms" class="gmf-nav-badge gmf-nav-badge--purple">{{ navCounts.rooms }}</span>
            </a>
          </li>
        </router-link>
        <li
          v-else-if="!hasPaidSubscription"
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item enhanced-menu-item tw-rounded-xl premium-menu-item premium-disabled"
        >
          <a
            href="#"
            class="menu-link enhanced-menu-link premium-disabled-link"
            v-b-tooltip.hover.right="lockedPlanTooltipOpts"
            @click.prevent="redirectToBilling"
          >
            <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-hotel"></i>
            <span class="menu-text">Room Reservations</span>
          </a>
        </li>
        <router-link
          v-if="isSessionBookingsEnabled"
          to="/business/package-bookings"
          v-slot="{ href, navigate, isActive, isExactActive }"
        >
          <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-menu-item tw-rounded-xl" :class="[
            isActive && 'menu-item-active',
            isExactActive && 'menu-item-active',
          ]">
            <a :href="href" class="menu-link enhanced-menu-link tw-flex tw-items-center tw-gap-3 tw-rounded-xl tw-px-3 tw-py-2.5 tw-no-underline" @click="navigate">
              <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-ticket-confirmation"></i>
              <span class="menu-text">Session Bookings</span>
              <span v-if="navCounts.packages" class="gmf-nav-badge gmf-nav-badge--green">{{ navCounts.packages }}</span>
            </a>
          </li>
        </router-link>
      </template>

      <li class="menu-section enhanced-section tw-flex tw-items-center tw-justify-between">
        <h4 class="menu-text">Manage</h4>
      </li>
      <template v-if="hasPermission('view menues')">
        <li
          aria-haspopup="true"
          class="menu-item menu-item-submenu enhanced-menu-item tw-rounded-xl"
          :class="{ 'menu-item-open': isMenuManagerOpen }"
        >
          <a
            href="#"
            class="menu-link menu-toggle enhanced-menu-link tw-flex tw-items-center tw-gap-3 tw-rounded-xl tw-px-3 tw-py-2.5 tw-no-underline"
            @click.prevent="toggleMenuManager"
          >
            <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-food"></i>
            <span class="menu-text">Menu</span>
            <i class="mdi mdi-chevron-down gmf-submenu-caret"></i>
          </a>
          <div class="menu-submenu enhanced-submenu">
            <span class="menu-arrow"></span>
            <ul class="menu-subnav">
              <li aria-haspopup="true" class="menu-item menu-item-parent">
                <span class="menu-link">
                  <span class="menu-text">Menu</span>
                </span>
              </li>
              <router-link to="/menu-manager/categories" v-slot="{ href, navigate, isActive, isExactActive }">
                <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-submenu-item tw-rounded-lg" :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active',
                ]">
                  <a :href="href" class="menu-link enhanced-submenu-link tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-py-2 tw-pl-3 tw-pr-2 tw-no-underline" @click="navigate">
                    <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-shape-outline"></i>
                    <span class="menu-text">Categories</span>
                  </a>
                </li>
              </router-link>
              <router-link to="/menu-manager/variants" v-slot="{ href, navigate, isActive, isExactActive }">
                <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-submenu-item tw-rounded-lg" :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active',
                ]">
                  <a :href="href" class="menu-link enhanced-submenu-link tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-py-2 tw-pl-3 tw-pr-2 tw-no-underline" @click="navigate">
                    <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-format-list-checks"></i>
                    <span class="menu-text">Variants</span>
                  </a>
                </li>
              </router-link>
              <router-link to="/menu-manager/products" v-slot="{ href, navigate, isActive, isExactActive }">
                <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-submenu-item tw-rounded-lg" :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active',
                ]">
                  <a :href="href" class="menu-link enhanced-submenu-link tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-py-2 tw-pl-3 tw-pr-2 tw-no-underline" @click="navigate">
                    <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-food"></i>
                    <span class="menu-text">Products</span>
                  </a>
                </li>
              </router-link>
              <router-link to="/menu-manager/properties" v-slot="{ href, navigate, isActive, isExactActive }">
                <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-submenu-item tw-rounded-lg" :class="[
                  isActive && 'menu-item-active',
                  isExactActive && 'menu-item-active',
                ]">
                  <a :href="href" class="menu-link enhanced-submenu-link tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-py-2 tw-pl-3 tw-pr-2 tw-no-underline" @click="navigate">
                    <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-tag-multiple"></i>
                    <span class="menu-text">Dish Options/Attributes</span>
                  </a>
                </li>
              </router-link>
            </ul>
          </div>
        </li>
      </template>
      <li
        aria-haspopup="true"
        class="menu-item menu-item-submenu enhanced-menu-item tw-rounded-xl"
        :class="{ 'menu-item-open': isMarketingOpen }"
      >
        <a
          href="#"
          class="menu-link menu-toggle enhanced-menu-link tw-flex tw-items-center tw-gap-3 tw-rounded-xl tw-px-3 tw-py-2.5 tw-no-underline"
          @click.prevent="toggleMarketing"
        >
          <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-bullhorn-outline"></i>
          <span class="menu-text">Marketing</span>
          <i class="mdi mdi-chevron-down gmf-submenu-caret"></i>
        </a>
        <div class="menu-submenu enhanced-submenu">
          <span class="menu-arrow"></span>
          <ul class="menu-subnav">
            <li aria-haspopup="true" class="menu-item menu-item-parent">
              <span class="menu-link">
                <span class="menu-text">Marketing</span>
              </span>
            </li>
            <router-link
              v-if="canUseEmailMarketing"
              to="/marketing/campaigns"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-submenu-item tw-rounded-lg premium-menu-item" :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]">
                <a :href="href" class="menu-link enhanced-submenu-link tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-py-2 tw-pl-3 tw-pr-2 tw-no-underline" @click="navigate">
                  <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-bullhorn-outline"></i>
                  <span class="menu-text">Marketing Campaigns</span>
                </a>
              </li>
            </router-link>
            <li
              v-else
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item enhanced-submenu-item tw-rounded-lg premium-menu-item premium-disabled"
            >
              <a
                href="#"
                class="menu-link enhanced-submenu-link premium-disabled-link"
                v-b-tooltip.hover.right="lockedGrowthTooltipOpts"
                @click.prevent="redirectToBilling"
              >
                <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-bullhorn-outline"></i>
                <span class="menu-text">Marketing Campaigns</span>
              </a>
            </li>
            <router-link
              v-if="canUseEmailMarketing"
              to="/marketing/email-templates"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-submenu-item tw-rounded-lg premium-menu-item" :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]">
                <a :href="href" class="menu-link enhanced-submenu-link tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-py-2 tw-pl-3 tw-pr-2 tw-no-underline" @click="navigate">
                  <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-email-edit-outline"></i>
                  <span class="menu-text">Email Templates</span>
                </a>
              </li>
            </router-link>
            <li
              v-else
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item enhanced-submenu-item tw-rounded-lg premium-menu-item premium-disabled"
            >
              <a
                href="#"
                class="menu-link enhanced-submenu-link premium-disabled-link"
                v-b-tooltip.hover.right="lockedGrowthTooltipOpts"
                @click.prevent="redirectToBilling"
              >
                <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-email-edit-outline"></i>
                <span class="menu-text">Email Templates</span>
              </a>
            </li>
            <router-link
              v-if="canUseEmailMarketing"
              to="/marketing/customer-lists"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-submenu-item tw-rounded-lg premium-menu-item" :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]">
                <a :href="href" class="menu-link enhanced-submenu-link tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-py-2 tw-pl-3 tw-pr-2 tw-no-underline" @click="navigate">
                  <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-account-group-outline"></i>
                  <span class="menu-text">Customer Lists</span>
                </a>
              </li>
            </router-link>
            <li
              v-else
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item enhanced-submenu-item tw-rounded-lg premium-menu-item premium-disabled"
            >
              <a
                href="#"
                class="menu-link enhanced-submenu-link premium-disabled-link"
                v-b-tooltip.hover.right="lockedGrowthTooltipOpts"
                @click.prevent="redirectToBilling"
              >
                <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-account-group-outline"></i>
                <span class="menu-text">Customer Lists</span>
              </a>
            </li>
          </ul>
        </div>
      </li>
      <router-link
        v-if="canUseAdvancedReports"
        to="/business/advanced-sales-reports"
        v-slot="{ href, navigate, isActive, isExactActive }"
      >
        <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-menu-item tw-rounded-xl premium-menu-item" :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]">
          <a
            :href="href"
            class="menu-link enhanced-menu-link tw-flex tw-items-center tw-gap-3 tw-rounded-xl tw-px-3 tw-py-2.5 tw-no-underline"
            @click="navigate"
          >
            <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-chart-bar"></i>
            <span class="menu-text">Advanced Sales Reports</span>
          </a>
        </li>
      </router-link>
      <li
        v-else
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item enhanced-menu-item tw-rounded-xl premium-menu-item premium-disabled"
      >
        <a
          href="#"
          class="menu-link enhanced-menu-link premium-disabled-link"
          v-b-tooltip.hover.right="lockedGrowthTooltipOpts"
          @click.prevent="redirectToBilling"
        >
          <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-chart-bar"></i>
          <span class="menu-text">Advanced Sales Reports</span>
        </a>
      </li>
      <li class="menu-section enhanced-section tw-flex tw-items-center tw-justify-between">
        <h4 class="menu-text">Settings</h4>
      </li>

      <li 
        aria-haspopup="true" 
        v-if="hasPermission('view business settings')"
        class="menu-item menu-item-submenu enhanced-menu-item tw-rounded-xl" 
        :class="{
          'menu-item-open': isBusinessSettingsOpen || hasActiveChildren('/custom-error/error'),
        }"
      >
        <a href="#" class="menu-link menu-toggle enhanced-menu-link tw-flex tw-items-center tw-gap-3 tw-rounded-xl tw-px-3 tw-py-2.5 tw-no-underline" @click.prevent="toggleBusinessSettings">
          <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-briefcase-outline"></i>
          <span class="menu-text">Business Setting</span>
          <i class="mdi mdi-chevron-down gmf-submenu-caret"></i>
        </a>
        <div 
          class="menu-submenu enhanced-submenu"
        >
          <span class="menu-arrow"></span>
          <ul class="menu-subnav">
            <li aria-haspopup="true" class="menu-item menu-item-parent">
              <span class="menu-link">
                <span class="menu-text">Business Setting</span>
              </span>
            </li>

            <router-link to="/business/templateinfo" v-slot="{ href, navigate, isActive, isExactActive }">
              <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-submenu-item tw-rounded-lg" :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]">
                <a :href="href" class="menu-link enhanced-submenu-link tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-py-2 tw-pl-3 tw-pr-2 tw-no-underline" @click="navigate">
                  <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-palette-outline"></i>
                  <span class="menu-text">Theme</span>
                </a>
              </li>
            </router-link>
            <router-link
              v-if="hasPaidSubscription && hasPermission('')"
              to="/business/staff"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-submenu-item tw-rounded-lg premium-menu-item" :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]">
                <a
                  :href="href"
                  class="menu-link enhanced-submenu-link tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-py-2 tw-pl-3 tw-pr-2 tw-no-underline"
                  @click="navigate"
                >
                  <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-account-tie"></i>
                  <span class="menu-text">Staff</span>
                </a>
              </li>
            </router-link>
            <li
              v-else
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item enhanced-submenu-item tw-rounded-lg premium-menu-item premium-disabled"
            >
              <a
                href="#"
                class="menu-link enhanced-submenu-link premium-disabled-link"
                v-b-tooltip.hover.right="lockedPlanTooltipOpts"
                @click.prevent="redirectToBilling"
              >
                <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-account-tie"></i>
                <span class="menu-text">Staff</span>
              </a>
            </li>
            <router-link to="/business/customers" v-slot="{ href, navigate, isActive, isExactActive }">
              <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-submenu-item tw-rounded-lg" :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]">
                <a :href="href" class="menu-link enhanced-submenu-link tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-py-2 tw-pl-3 tw-pr-2 tw-no-underline" @click="navigate">
                  <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-account-multiple-outline"></i>
                  <span class="menu-text">Customers</span>
                </a>
              </li>
            </router-link>
            <router-link
              v-if="hasPaidSubscription && $canUseMultilocations()"
              to="/business/branches"
              v-slot="{ href, navigate, isActive, isExactActive }"
            >
              <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-submenu-item tw-rounded-lg premium-menu-item" :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]">
                <a
                  :href="href"
                  class="menu-link enhanced-submenu-link tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-py-2 tw-pl-3 tw-pr-2 tw-no-underline"
                  @click="navigate"
                >
                  <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-store"></i>
                  <span class="menu-text">Branches</span>
                </a>
              </li>
            </router-link>
            <li
              v-else
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item enhanced-submenu-item tw-rounded-lg premium-menu-item premium-disabled"
            >
              <a
                href="#"
                class="menu-link enhanced-submenu-link premium-disabled-link"
                v-b-tooltip.hover.right="lockedGrowthTooltipOpts"
                @click.prevent="redirectToBilling"
              >
                <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-store"></i>
                <span class="menu-text">Branches</span>
              </a>
            </li>
            <router-link to="/business/contact-us" v-slot="{ href, navigate, isActive, isExactActive }">
              <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-submenu-item tw-rounded-lg" :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]">
                <a :href="href" class="menu-link enhanced-submenu-link tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-py-2 tw-pl-3 tw-pr-2 tw-no-underline" @click="navigate">
                  <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-message-text-outline"></i>
                  <span class="menu-text">Messages</span>
                </a>
              </li>
            </router-link>
            <router-link to="/business/announcements" v-slot="{ href, navigate, isActive, isExactActive }">
              <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-submenu-item tw-rounded-lg" :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]">
                <a :href="href" class="menu-link enhanced-submenu-link tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-py-2 tw-pl-3 tw-pr-2 tw-no-underline" @click="navigate">
                  <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-ticket-percent"></i>
                  <span class="menu-text">Discounts / Vouchers</span>
                </a>
              </li>
            </router-link>
            <router-link to="/business/gift-vouchers" v-slot="{ href, navigate, isActive, isExactActive }">
              <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-submenu-item tw-rounded-lg" :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]">
                <a :href="href" class="menu-link enhanced-submenu-link tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-py-2 tw-pl-3 tw-pr-2 tw-no-underline" @click="navigate">
                  <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-gift-outline"></i>
                  <span class="menu-text">Gift Vouchers</span>
                </a>
              </li>
            </router-link>
            <router-link to="/business/packages" v-slot="{ href, navigate, isActive, isExactActive }">
              <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-submenu-item tw-rounded-lg" :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]">
                <a :href="href" class="menu-link enhanced-submenu-link tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-py-2 tw-pl-3 tw-pr-2 tw-no-underline" @click="navigate">
                  <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-balloon"></i>
                  <span class="menu-text">Sessions & Parties</span>
                </a>
              </li>
            </router-link>
            <router-link to="/business/offers" v-slot="{ href, navigate, isActive, isExactActive }">
              <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-submenu-item tw-rounded-lg" :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]">
                <a :href="href" class="menu-link enhanced-submenu-link tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-py-2 tw-pl-3 tw-pr-2 tw-no-underline" @click="navigate">
                  <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-sale"></i>
                  <span class="menu-text">Offers</span>
                </a>
              </li>
            </router-link>
            <router-link to="/business/announcement" v-slot="{ href, navigate, isActive, isExactActive }">
              <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-submenu-item tw-rounded-lg" :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]">
                <a :href="href" class="menu-link enhanced-submenu-link tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-py-2 tw-pl-3 tw-pr-2 tw-no-underline" @click="navigate">
                  <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-bell-outline"></i>
                  <span class="menu-text">Announcements</span>
                </a>
              </li>
            </router-link>
            <router-link to="/business/reservation-settings" v-slot="{ href, navigate, isActive, isExactActive }">
              <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-submenu-item tw-rounded-lg" :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]">
                <a :href="href" class="menu-link enhanced-submenu-link tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-py-2 tw-pl-3 tw-pr-2 tw-no-underline" @click="navigate">
                  <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-calendar-clock"></i>
                  <span class="menu-text">Reservation Settings</span>
                </a>
              </li>
            </router-link>
            <router-link to="/business/settings" v-slot="{ href, navigate, isActive, isExactActive }">
              <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-submenu-item tw-rounded-lg" :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]">
                <a :href="href" class="menu-link enhanced-submenu-link tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-py-2 tw-pl-3 tw-pr-2 tw-no-underline" @click="navigate">
                  <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-settings"></i>
                  <span class="menu-text">Settings</span>
                </a>
              </li>
            </router-link>
          </ul>
        </div>
      </li>

      <li 
        aria-haspopup="true" 
        class="menu-item menu-item-submenu enhanced-menu-item tw-rounded-xl"
        :class="{
          'menu-item-open': isSystemSettingsOpen || hasActiveChildren('/custom-error/error'),
        }" 
        v-if="hasPermission('view system settings')"
      >
        <a href="#" class="menu-link menu-toggle enhanced-menu-link tw-flex tw-items-center tw-gap-3 tw-rounded-xl tw-px-3 tw-py-2.5 tw-no-underline" @click.prevent="toggleSystemSettings">
          <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-tune"></i>
          <span class="menu-text">System Settings</span>
          <i class="mdi mdi-chevron-down gmf-submenu-caret"></i>
        </a>
        <div 
          class="menu-submenu enhanced-submenu"
        >
          <span class="menu-arrow"></span>
          <ul class="menu-subnav">
            <li aria-haspopup="true" class="menu-item menu-item-parent">
              <span class="menu-link">
                <span class="menu-text">System Settings</span>
              </span>
            </li>

            <router-link to="/system-setting/contact-details" v-slot="{ href, navigate, isActive, isExactActive }">
              <li class="menu-item enhanced-submenu-item tw-rounded-lg" :class="[isActive && 'menu-item-active']">
                <a :href="href" class="menu-link enhanced-submenu-link tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-py-2 tw-pl-3 tw-pr-2 tw-no-underline" @click="navigate">
                  <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-phone-outline"></i>
                  <span class="menu-text">Contact Details</span>
                </a>
              </li>
            </router-link>

            <router-link to="/system-setting/restaurant-details" v-slot="{ href, navigate, isActive }">
              <li class="menu-item enhanced-submenu-item tw-rounded-lg" :class="[isActive && 'menu-item-active']">
                <a :href="href" class="menu-link enhanced-submenu-link tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-py-2 tw-pl-3 tw-pr-2 tw-no-underline" @click="navigate">
                  <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-silverware-fork-knife"></i>
                  <span class="menu-text">Restaurant Details</span>
                </a>
              </li>
            </router-link>

            <router-link to="/system-setting/menu-details" v-slot="{ href, navigate, isActive }">
              <li class="menu-item enhanced-submenu-item tw-rounded-lg" :class="[isActive && 'menu-item-active']">
                <a :href="href" class="menu-link enhanced-submenu-link tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-py-2 tw-pl-3 tw-pr-2 tw-no-underline" @click="navigate">
                  <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-book-open-page-variant"></i>
                  <span class="menu-text">Menu Details</span>
                </a>
              </li>
            </router-link>

            <router-link to="/system-setting/social-link-details" v-slot="{ href, navigate, isActive }">
              <li class="menu-item enhanced-submenu-item tw-rounded-lg" :class="[isActive && 'menu-item-active']">
                <a :href="href" class="menu-link enhanced-submenu-link tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-py-2 tw-pl-3 tw-pr-2 tw-no-underline" @click="navigate">
                  <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-share-variant"></i>
                  <span class="menu-text">Social Link Details</span>
                </a>
              </li>
            </router-link>

            <router-link to="/system-setting/branding-details" v-slot="{ href, navigate, isActive }">
              <li class="menu-item enhanced-submenu-item tw-rounded-lg" :class="[isActive && 'menu-item-active']">
                <a :href="href" class="menu-link enhanced-submenu-link tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-py-2 tw-pl-3 tw-pr-2 tw-no-underline" @click="navigate">
                  <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-palette-swatch"></i>
                  <span class="menu-text">Branding Details</span>
                </a>
              </li>
            </router-link>

            <router-link to="/system-setting/opening-timings-details" v-slot="{ href, navigate, isActive }">
              <li class="menu-item enhanced-submenu-item tw-rounded-lg" :class="[isActive && 'menu-item-active']">
                <a :href="href" class="menu-link enhanced-submenu-link tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-py-2 tw-pl-3 tw-pr-2 tw-no-underline" @click="navigate">
                  <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-clock-outline"></i>
                  <span class="menu-text">Opening Timings Details</span>
                </a>
              </li>
            </router-link>

            <router-link to="/system-setting/delivery-charges-details" v-slot="{ href, navigate, isActive }">
              <li class="menu-item enhanced-submenu-item tw-rounded-lg" :class="[isActive && 'menu-item-active']">
                <a :href="href" class="menu-link enhanced-submenu-link tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-py-2 tw-pl-3 tw-pr-2 tw-no-underline" @click="navigate">
                  <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-cash-multiple"></i>
                  <span class="menu-text">Delivery Charges </span>
                </a>
              </li>
            </router-link>

            <router-link to="/system-setting/delivery-collection-details" v-slot="{ href, navigate, isActive }">
              <li class="menu-item enhanced-submenu-item tw-rounded-lg" :class="[isActive && 'menu-item-active']">
                <a :href="href" class="menu-link enhanced-submenu-link tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-py-2 tw-pl-3 tw-pr-2 tw-no-underline" @click="navigate">
                  <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-package-variant-closed"></i>
                  <span class="menu-text">Delivery Collection Details</span>
                </a>
              </li>
            </router-link>

            <router-link to="/system-setting/domain" v-slot="{ href, navigate, isActive }">
              <li class="menu-item enhanced-submenu-item tw-rounded-lg" :class="[isActive && 'menu-item-active']">
                <a :href="href" class="menu-link enhanced-submenu-link tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-py-2 tw-pl-3 tw-pr-2 tw-no-underline" @click="navigate">
                  <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-web"></i>
                  <span class="menu-text">Domain</span>
                </a>
              </li>
            </router-link>

            <router-link to="/system-setting/billing" v-slot="{ href, navigate, isActive }">
              <li class="menu-item enhanced-submenu-item tw-rounded-lg" :class="[isActive && 'menu-item-active']">
                <a :href="href" class="menu-link enhanced-submenu-link tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-py-2 tw-pl-3 tw-pr-2 tw-no-underline" @click="navigate">
                  <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-credit-card"></i>
                  <span class="menu-text">Billing</span>
                </a>
              </li>
            </router-link>

            <router-link to="/system-setting/qrcode" v-slot="{ href, navigate, isActive }">
              <li class="menu-item enhanced-submenu-item tw-rounded-lg" :class="[isActive && 'menu-item-active']">
                <a :href="href" class="menu-link enhanced-submenu-link tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-py-2 tw-pl-3 tw-pr-2 tw-no-underline" @click="navigate">
                  <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-qrcode"></i>
                  <span class="menu-text">QR Code</span>
                </a>
              </li>
            </router-link>

            <router-link to="/system-setting/account-delete" v-slot="{ href, navigate, isActive }">
              <li class="menu-item enhanced-submenu-item tw-rounded-lg" :class="[isActive && 'menu-item-active']">
                <a :href="href" class="menu-link enhanced-submenu-link tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-py-2 tw-pl-3 tw-pr-2 tw-no-underline" @click="navigate">
                  <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-toggle-switch-outline"></i>
                  <span class="menu-text">Website Status</span>
                </a>
              </li>
            </router-link>
            <router-link to="/system-setting/loyality-settings" v-slot="{ href, navigate, isActive, isExactActive }">
              <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-submenu-item tw-rounded-lg" :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]">
                <a :href="href" class="menu-link enhanced-submenu-link tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-py-2 tw-pl-3 tw-pr-2 tw-no-underline" @click="navigate">
                  <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-star-circle-outline"></i>
                  <span class="menu-text">Loyality Settings</span>
                </a>
              </li>
            </router-link>
          </ul>
        </div>
      </li>
    </ul>

    <ul class="menu-nav enhanced-sidebar" v-else-if="$store.state.auth.isAuthenticated && !$store.state.auth.normal && !isAgentUser">
      <router-link :to="{ name: 'admindashboard' }" v-slot="{ href, navigate, isExactActive }">
        <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-menu-item tw-rounded-xl"
          :class="[isExactActive && 'menu-item-active']">
          <a :href="href" class="menu-link enhanced-menu-link tw-flex tw-items-center tw-gap-3 tw-rounded-xl tw-px-3 tw-py-2.5 tw-no-underline" @click="navigate">
            <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-view-dashboard-outline"></i>
            <span class="menu-text">Dashboard</span>
          </a>
        </li>
      </router-link>

      <router-link to="/admin/businesses" v-slot="{ href, navigate, isActive, isExactActive }">
        <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-menu-item tw-rounded-xl"
          :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
          <a :href="href" class="menu-link enhanced-menu-link tw-flex tw-items-center tw-gap-3 tw-rounded-xl tw-px-3 tw-py-2.5 tw-no-underline" @click="navigate">
            <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-briefcase-outline"></i>
            <span class="menu-text">Businesses</span>
          </a>
        </li>
      </router-link>

      <router-link to="/admin/billing" v-slot="{ href, navigate, isActive, isExactActive }">
        <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-menu-item tw-rounded-xl"
          :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
          <a :href="href" class="menu-link enhanced-menu-link tw-flex tw-items-center tw-gap-3 tw-rounded-xl tw-px-3 tw-py-2.5 tw-no-underline" @click="navigate">
            <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-credit-card"></i>
            <span class="menu-text">Billing</span>
          </a>
        </li>
      </router-link>
      <!-- 
    <router-link to="/admin/reservation" v-slot="{ href, navigate, isActive, isExactActive }">
      <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-menu-item tw-rounded-xl"
        :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
        <a :href="href" class="menu-link enhanced-menu-link tw-flex tw-items-center tw-gap-3 tw-rounded-xl tw-px-3 tw-py-2.5 tw-no-underline" @click="navigate">
          <i class="mdi mdi-calendar-outline menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90"></i>
          <span class="menu-text">Table Reservations</span>
        </a>
      </li>
    </router-link>

    <router-link to="/admin/categories" v-slot="{ href, navigate, isActive, isExactActive }">
      <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-menu-item tw-rounded-xl"
        :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
        <a :href="href" class="menu-link enhanced-menu-link tw-flex tw-items-center tw-gap-3 tw-rounded-xl tw-px-3 tw-py-2.5 tw-no-underline" @click="navigate">
          <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-shape-outline"></i>
          <span class="menu-text">Categories</span>
        </a>
      </li>
    </router-link>

    <router-link to="/admin/dish-properties" v-slot="{ href, navigate, isActive, isExactActive }">
      <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-menu-item tw-rounded-xl"
        :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
        <a :href="href" class="menu-link enhanced-menu-link tw-flex tw-items-center tw-gap-3 tw-rounded-xl tw-px-3 tw-py-2.5 tw-no-underline" @click="navigate">
          <i class="mdi mdi-palette-outline menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90"></i>
          <span class="menu-text">Dish Properties</span>
        </a>
      </li>
    </router-link>

    <router-link to="/admin/dish-properties-group" v-slot="{ href, navigate, isActive, isExactActive }">
      <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-menu-item tw-rounded-xl"
        :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
        <a :href="href" class="menu-link enhanced-menu-link tw-flex tw-items-center tw-gap-3 tw-rounded-xl tw-px-3 tw-py-2.5 tw-no-underline" @click="navigate">
          <i class="mdi mdi-palette-outline menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90"></i>
          <span class="menu-text">Dish Properties Group</span>
        </a>
      </li>
    </router-link> -->
      <!-- 
    <router-link to="/admin/toppings" v-slot="{ href, navigate, isActive, isExactActive }">
      <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-menu-item tw-rounded-xl"
        :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
        <a :href="href" class="menu-link enhanced-menu-link tw-flex tw-items-center tw-gap-3 tw-rounded-xl tw-px-3 tw-py-2.5 tw-no-underline" @click="navigate">
          <i class="mdi mdi-pizza menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90"></i>
          <span class="menu-text">Toppings</span>
        </a>
      </li>
    </router-link>

    <router-link to="/admin/topping-groups" v-slot="{ href, navigate, isActive, isExactActive }">
      <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-menu-item tw-rounded-xl"
        :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
        <a :href="href" class="menu-link enhanced-menu-link tw-flex tw-items-center tw-gap-3 tw-rounded-xl tw-px-3 tw-py-2.5 tw-no-underline" @click="navigate">
          <i class="mdi mdi-pizza menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90"></i>
          <span class="menu-text">Topping Groups</span>
        </a>
      </li>
    </router-link>

    <router-link to="/admin/items" v-slot="{ href, navigate, isActive, isExactActive }">
      <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-menu-item tw-rounded-xl"
        :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
        <a :href="href" class="menu-link enhanced-menu-link tw-flex tw-items-center tw-gap-3 tw-rounded-xl tw-px-3 tw-py-2.5 tw-no-underline" @click="navigate">
          <i class="mdi mdi-basket menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90"></i>
          <span class="menu-text">Items</span>
        </a>
      </li>
    </router-link>

    <router-link to="/admin/opening-times" v-slot="{ href, navigate, isActive, isExactActive }">
      <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-menu-item tw-rounded-xl"
        :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
        <a :href="href" class="menu-link enhanced-menu-link tw-flex tw-items-center tw-gap-3 tw-rounded-xl tw-px-3 tw-py-2.5 tw-no-underline" @click="navigate">
          <i class="mdi mdi-clock-outline menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90"></i>
          <span class="menu-text">Opening Times</span>
        </a>
      </li>
    </router-link>

    <router-link to="/admin/delivery-collection-timings" v-slot="{ href, navigate, isActive, isExactActive }">
      <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-menu-item tw-rounded-xl"
        :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
        <a :href="href" class="menu-link enhanced-menu-link tw-flex tw-items-center tw-gap-3 tw-rounded-xl tw-px-3 tw-py-2.5 tw-no-underline" @click="navigate">
          <i class="mdi mdi-truck-delivery menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90"></i>
          <span class="menu-text">Delivery & Collection Timings</span>
        </a>
      </li>
    </router-link>

    <router-link to="/admin/orders" v-slot="{ href, navigate, isActive, isExactActive }">
      <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-menu-item tw-rounded-xl"
        :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
        <a :href="href" class="menu-link enhanced-menu-link tw-flex tw-items-center tw-gap-3 tw-rounded-xl tw-px-3 tw-py-2.5 tw-no-underline" @click="navigate">
          <i class="mdi mdi-cart-minus menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90"></i>
          <span class="menu-text">Orders</span>
        </a>
      </li>
    </router-link>

    <router-link to="/admin/vouchers" v-slot="{ href, navigate, isActive, isExactActive }">
      <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-menu-item tw-rounded-xl"
        :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
        <a :href="href" class="menu-link enhanced-menu-link tw-flex tw-items-center tw-gap-3 tw-rounded-xl tw-px-3 tw-py-2.5 tw-no-underline" @click="navigate">
          <i class="mdi mdi-gift-outline menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90"></i>
          <span class="menu-text">Voucher Codes</span>
        </a>
      </li>
    </router-link>

    <router-link to="/admin/user-vouchers" v-slot="{ href, navigate, isActive, isExactActive }">
      <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-menu-item tw-rounded-xl"
        :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
        <a :href="href" class="menu-link enhanced-menu-link tw-flex tw-items-center tw-gap-3 tw-rounded-xl tw-px-3 tw-py-2.5 tw-no-underline" @click="navigate">
          <i class="mdi mdi-gift-outline menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90"></i>
          <span class="menu-text">Used Vouchers</span>
        </a>
      </li>
    </router-link> -->
      <!-- <router-link to="/admin/transaction-fee-setting" v-slot="{ href, navigate, isActive, isExactActive }">
      <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-menu-item tw-rounded-xl"
        :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
        <a :href="href" class="menu-link enhanced-menu-link tw-flex tw-items-center tw-gap-3 tw-rounded-xl tw-px-3 tw-py-2.5 tw-no-underline" @click="navigate">
          <i class="mdi mdi-credit-card-settings menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90"></i>
          <span class="menu-text">Card Fees Setting</span>
        </a>
      </li>
    </router-link> -->

      <router-link to="/admin/agents" v-slot="{ href, navigate, isActive, isExactActive }">
        <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-menu-item tw-rounded-xl"
          :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
          <a :href="href" class="menu-link enhanced-menu-link tw-flex tw-items-center tw-gap-3 tw-rounded-xl tw-px-3 tw-py-2.5 tw-no-underline" @click="navigate">
            <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-account-supervisor"></i>
            <span class="menu-text">Agents</span>
          </a>
        </li>
      </router-link>
      
      <li
        aria-haspopup="true"
        class="menu-item menu-item-submenu enhanced-menu-item tw-mx-2 tw-rounded-md sa-settings-item"
        :class="{
          'menu-item-open': isAdminSettingsOpen || isAdminEmailPricingRoute || isAdminSmsPricingRoute,
          'menu-item-active': isAdminEmailPricingRoute || isAdminSmsPricingRoute,
        }"
      >
        <a href="javascript:void(0);" class="menu-link menu-toggle enhanced-menu-link tw-flex tw-items-center tw-gap-3 tw-rounded-xl tw-px-3 tw-py-2.5 tw-no-underline" @click.prevent="toggleAdminSettings">
          <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-settings"></i>
          <span class="menu-text">Settings</span>
          <i class="mdi mdi-chevron-down sa-submenu-caret"></i>
        </a>
        <div class="menu-submenu enhanced-submenu sa-submenu">
          <ul class="menu-subnav">
            <router-link to="/admin/email-pricing" v-slot="{ href, navigate, isActive, isExactActive }">
              <li
                aria-haspopup="true"
                class="menu-item enhanced-submenu-item tw-rounded-lg"
                :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
              >
                <a :href="href" class="menu-link enhanced-submenu-link tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-py-2 tw-pl-3 tw-pr-2 tw-no-underline" @click="navigate">
                  <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-email-outline"></i>
                  <span class="menu-text">Email Pricing</span>
                </a>
              </li>
            </router-link>
            <router-link to="/admin/sms-pricing" v-slot="{ href, navigate, isActive, isExactActive }">
              <li
                aria-haspopup="true"
                class="menu-item enhanced-submenu-item tw-rounded-lg"
                :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
              >
                <a :href="href" class="menu-link enhanced-submenu-link tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-py-2 tw-pl-3 tw-pr-2 tw-no-underline" @click="navigate">
                  <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-message-processing"></i>
                  <span class="menu-text">SMS Service</span>
                </a>
              </li>
            </router-link>
          </ul>
        </div>
      </li>
    </ul>

    <!-- Agent Menu Section -->
    <ul class="menu-nav enhanced-sidebar" v-if="isAgentUser">
      <router-link to="/admin/leads" v-slot="{ href, navigate, isActive, isExactActive }">
        <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item enhanced-menu-item tw-rounded-xl"
          :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
          <a :href="href" class="menu-link enhanced-menu-link tw-flex tw-items-center tw-gap-3 tw-rounded-xl tw-px-3 tw-py-2.5 tw-no-underline" @click="navigate">
            <i class="menu-icon tw-inline-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-bg-transparent tw-text-current tw-opacity-90 mdi mdi-file-document-edit-outline"></i>
            <span class="menu-text">Proposals</span>
          </a>
        </li>
      </router-link>
    </ul>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { authGet, authSet } from "@/core/services/auth-storage";
import ApiService from "@/core/services/api.service";
import MenuNotificationsMixin from "./menu-notifications.mixin";
import { canAccess } from "@/core/plugins/Subscription.js";

export default {
  mixins: [MenuNotificationsMixin],
  data() {
    return {
      isAudioEnabled: false,
      set_branch: authGet("SELECTED_BRANCH") || "0",
      isStaff: false,
      staffInfo: null,
      isAgent: false,
      agentInfo: null,
      isBusinessSettingsOpen: false,
      isSystemSettingsOpen: false,
      isAdminSettingsOpen: false,
      isMenuManagerOpen: false,
      isMarketingOpen: false,
      businessSettingsTimeout: null,
      systemSettingsTimeout: null,
      adminSettingsTimeout: null,
      businessSettingsJustOpened: false,
      systemSettingsJustOpened: false,
      adminSettingsJustOpened: false,
      menuManagerJustOpened: false,
      marketingJustOpened: false,
      navCounts: {
        today: 0,
        upcoming: 0,
        tables: 0,
        rooms: 0,
        packages: 0
      },
      packagesEnabled: authGet("packages_enabled") === "1",
      roomReservationsEnabled: authGet("enable_room_reservations") === "1"

    };
  },
  computed: {
    // Computed property to check if user is an agent
    isAgentUser() {
      // Check multiple sources for agent status
      const fromData = this.isAgent;
      const fromStore = this.$store.state.auth.user && this.$store.state.auth.user.user_type === 'AGENT';
      const fromSession = authGet('is_agent') === '1';

      return fromData || fromStore || fromSession;
    },
    // Check if room reservations are enabled
    isRoomReservationsEnabled() {
      return this.roomReservationsEnabled && this.hasPaidSubscription;
    },
    // Check if user has paid active subscription
    hasPaidSubscription() {
      return this.$hasPaidActiveSubscription();
    },
    canUseEmailMarketing() {
      return canAccess("emailSmsMarketing");
    },
    canUseAdvancedReports() {
      return canAccess("advancedSalesReports");
    },
    isSessionBookingsEnabled() {
      return this.packagesEnabled && this.hasPaidSubscription;
    },
    lockedPlanTooltip() {
      return "Upgrade to Starter to unlock this";
    },
    lockedPlanTooltipOpts() {
      return {
        title: this.lockedPlanTooltip,
        customClass: "gmf-upgrade-tooltip",
      };
    },
    lockedGrowthTooltip() {
      return "Upgrade to Growth to unlock this";
    },
    lockedGrowthTooltipOpts() {
      return {
        title: this.lockedGrowthTooltip,
        customClass: "gmf-upgrade-tooltip",
      };
    },
    isAdminEmailPricingRoute() {
      return this.$route.path.indexOf('/admin/email-pricing') !== -1;
    },
    isAdminSmsPricingRoute() {
      return this.$route.path.indexOf('/admin/sms-pricing') !== -1;
    }
  },
  watch: {
    $route(to) {
      this.loadNavCounts();
      this.loadPackagesEnabled();
      if (to && to.path && to.path.indexOf("/menu-manager") !== -1) {
        this.isMenuManagerOpen = true;
      }
      if (to && to.path && to.path.indexOf("/marketing") !== -1) {
        this.isMarketingOpen = true;
      }
    }
  },
  name: "KTMenu",

  mounted() {

    // this.verifyauth()

    this.listenForNotifications();
    this.checkStaffStatus();
    this.initializeAudio();
    this.loadNavCounts();
    this.loadPackagesEnabled();
    this.loadRoomReservationsEnabled();
    if (this.hasActiveChildren("/menu-manager")) {
      this.isMenuManagerOpen = true;
    }
    if (this.hasActiveChildren("/marketing")) {
      this.isMarketingOpen = true;
    }
    window.addEventListener("gmf-packages-enabled", this.onPackagesEnabledChange);
    window.addEventListener("gmf-room-reservations-enabled", this.onRoomReservationsEnabledChange);
    
    // Add click outside handler to close submenus
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    // Clean up timeouts
    if (this.businessSettingsTimeout) {
      clearTimeout(this.businessSettingsTimeout);
    }
    if (this.systemSettingsTimeout) {
      clearTimeout(this.systemSettingsTimeout);
    }
    if (this.adminSettingsTimeout) {
      clearTimeout(this.adminSettingsTimeout);
    }
    
    // Remove click outside handler
    document.removeEventListener('click', this.handleClickOutside);
    window.removeEventListener("gmf-packages-enabled", this.onPackagesEnabledChange);
    window.removeEventListener("gmf-room-reservations-enabled", this.onRoomReservationsEnabledChange);
    // Initialize Pusher
    //  Pusher.logToConsole = true;

    // const pusher = new Pusher('8f759dce5537c6587c47', {
    //     cluster: 'eu',
    //     //encrypted: true
    // });

    // // Subscribe to the 'orders' channel
    // const channel = pusher.subscribe('my-channel');

    // // Listen for the OrderShipped event
    // console.log('$store.state.auth',this.$store.state.auth.user.id)
    // channel.bind('my-event', (data) => {
    //     console.log('Order shipped:', data.order);
    //     if(this.$store.state.auth.user.id==data.message){
    //       this.$refs.hiddenButton.click();
    //     }

    // });


  },
  methods: {
    loadNavCounts() {
      if (!this.$store.state.auth.normal || this.isAgentUser) return;
      ApiService.get("business/sales/sidebar-counts")
        .then(({ data }) => {
          this.navCounts.today = Number(data.today_pending_orders) || 0;
          this.navCounts.upcoming = Number(data.upcoming_pending_orders) || 0;
          this.navCounts.tables = Number(data.pending_table_reservations) || 0;
          this.navCounts.rooms = Number(data.pending_room_reservations) || 0;
          this.navCounts.packages = Number(data.pending_package_bookings) || 0;
        })
        .catch(() => {});
    },
    verifyauth() {

      this.$store.dispatch("verifyAuth")
        .catch(() => {
          // If VERIFY_AUTH fails (i.e., user not authenticated), redirect to login
          this.$router.push({ name: "login" }); // Use your actual login route name or path
        });

    },
    showPremiumMessage() {
      Swal.fire({
        title: "Premium Feature",
        text: "This feature is available with a premium subscription. Upgrade your plan to access this feature.",
        icon: "info",
        confirmButtonText: "View Plans",
        showCancelButton: true,
        cancelButtonText: "Cancel"
      }).then((result) => {
        if (result.isConfirmed) {
          this.$router.push('/system-setting/billing');
        }
      });
    },
    redirectToBilling() {
      this.$router.push('/system-setting/billing');
    },
    onPackagesEnabledChange(event) {
      const value = event && event.detail != null ? String(event.detail) : authGet("packages_enabled");
      this.packagesEnabled = value === "1";
    },
    onRoomReservationsEnabledChange(event) {
      const value = event && event.detail != null ? String(event.detail) : authGet("enable_room_reservations");
      this.roomReservationsEnabled = this.isSettingFlagOn(value);
    },
    isSettingFlagOn(value) {
      if (value == null || value === "") {
        return false;
      }
      let raw = value;
      if (typeof raw === "object") {
        raw = raw.value != null ? raw.value : "";
      }
      raw = String(raw).trim();
      if (
        (raw.charAt(0) === '"' && raw.charAt(raw.length - 1) === '"') ||
        (raw.charAt(0) === "'" && raw.charAt(raw.length - 1) === "'")
      ) {
        raw = raw.slice(1, -1);
      }
      return raw === "1" || raw === "true";
    },
    async loadRoomReservationsEnabled() {
      if (!this.$store.state.auth.normal) return;
      this.roomReservationsEnabled = this.isSettingFlagOn(authGet("enable_room_reservations"));
      try {
        const response = await ApiService.get("business/settings/get-general-settings");
        const rows = Array.isArray(response.data)
          ? response.data
          : (response.data && (response.data.data || response.data.settings)) || [];
        const row = rows.find((setting) => setting && setting.key === "enable_room_reservations");
        if (row) {
          const enabled = this.isSettingFlagOn(row.value) ? "1" : "0";
          authSet("enable_room_reservations", enabled);
          this.roomReservationsEnabled = enabled === "1";
        }
      } catch (e) {
        // Keep cached flag if the settings call fails
      }
    },
    async loadPackagesEnabled() {
      if (!this.$store.state.auth.normal) return;
      const cached = authGet("packages_enabled");
      if (cached === "1" || cached === "0") {
        this.packagesEnabled = cached === "1";
      }
      try {
        const response = await ApiService.get("business/settings/packages");
        const payload = response.data && response.data.data ? response.data.data : {};
        const enabled = String(payload.packages_enabled || "0") === "1" ? "1" : "0";
        authSet("packages_enabled", enabled);
        this.packagesEnabled = enabled === "1";
      } catch (e) {
        // Keep cached flag if the settings call fails
      }
    },
    // Business Settings submenu handlers
    toggleBusinessSettings(event) {
      // Prevent event bubbling
      if (event) {
        event.stopPropagation();
      }
      
      // Clear any pending close timeouts
      if (this.businessSettingsTimeout) {
        clearTimeout(this.businessSettingsTimeout);
        this.businessSettingsTimeout = null;
      }
      
      // Close other submenus first
      this.isSystemSettingsOpen = false;
      this.isAdminSettingsOpen = false;
      this.isMenuManagerOpen = false;
      this.isMarketingOpen = false;
      
      // Toggle this submenu
      const wasOpen = this.isBusinessSettingsOpen;
      this.isBusinessSettingsOpen = !this.isBusinessSettingsOpen;
      
      // If opening, set flag to prevent immediate close
      if (this.isBusinessSettingsOpen && !wasOpen) {
        this.businessSettingsJustOpened = true;
        setTimeout(() => {
          this.businessSettingsJustOpened = false;
        }, 500);
        
        this.$nextTick(() => {
          this.scrollToSubmenu('Business Setting');
        });
      } else if (wasOpen && !this.isBusinessSettingsOpen) {
        this.resetAsideScrollAfterCollapse();
      }
    },
    openBusinessSettings() {
      if (this.businessSettingsTimeout) {
        clearTimeout(this.businessSettingsTimeout);
        this.businessSettingsTimeout = null;
      }
      this.isBusinessSettingsOpen = true;
    },
    closeBusinessSettingsDelayed() {
      // Don't close if it was just opened
      if (this.businessSettingsJustOpened) {
        return;
      }
      
      this.businessSettingsTimeout = setTimeout(() => {
        // Double check it wasn't opened during the timeout
        if (!this.businessSettingsJustOpened) {
          this.isBusinessSettingsOpen = false;
        }
      }, 500); // Reduced delay
    },
    // System Settings submenu handlers
    toggleSystemSettings(event) {
      // Prevent event bubbling
      if (event) {
        event.stopPropagation();
      }
      
      // Clear any pending close timeouts
      if (this.systemSettingsTimeout) {
        clearTimeout(this.systemSettingsTimeout);
        this.systemSettingsTimeout = null;
      }
      
      // Close other submenus first
      this.isBusinessSettingsOpen = false;
      this.isAdminSettingsOpen = false;
      this.isMenuManagerOpen = false;
      this.isMarketingOpen = false;
      
      // Toggle this submenu
      const wasOpen = this.isSystemSettingsOpen;
      this.isSystemSettingsOpen = !this.isSystemSettingsOpen;
      
      // If opening, set flag to prevent immediate close
      if (this.isSystemSettingsOpen && !wasOpen) {
        this.systemSettingsJustOpened = true;
        setTimeout(() => {
          this.systemSettingsJustOpened = false;
        }, 500);
        
        this.$nextTick(() => {
          this.scrollToSubmenu('System Settings');
        });
      } else if (wasOpen && !this.isSystemSettingsOpen) {
        this.resetAsideScrollAfterCollapse();
      }
    },
    openSystemSettings() {
      if (this.systemSettingsTimeout) {
        clearTimeout(this.systemSettingsTimeout);
        this.systemSettingsTimeout = null;
      }
      this.isSystemSettingsOpen = true;
    },
    closeSystemSettingsDelayed() {
      // Don't close if it was just opened
      if (this.systemSettingsJustOpened) {
        return;
      }
      
      this.systemSettingsTimeout = setTimeout(() => {
        // Double check it wasn't opened during the timeout
        if (!this.systemSettingsJustOpened) {
          this.isSystemSettingsOpen = false;
        }
      }, 500); // Reduced delay
    },
    toggleMenuManager(event) {
      if (event) {
        event.stopPropagation();
      }
      this.isBusinessSettingsOpen = false;
      this.isSystemSettingsOpen = false;
      this.isAdminSettingsOpen = false;
      this.isMarketingOpen = false;
      const wasOpen = this.isMenuManagerOpen;
      this.isMenuManagerOpen = !this.isMenuManagerOpen;
      if (this.isMenuManagerOpen && !wasOpen) {
        this.menuManagerJustOpened = true;
        setTimeout(() => {
          this.menuManagerJustOpened = false;
        }, 500);
        this.$nextTick(() => {
          this.scrollToSubmenu("Menu");
        });
      } else if (wasOpen && !this.isMenuManagerOpen) {
        this.resetAsideScrollAfterCollapse();
      }
    },
    toggleMarketing(event) {
      if (event) {
        event.stopPropagation();
      }
      this.isBusinessSettingsOpen = false;
      this.isSystemSettingsOpen = false;
      this.isAdminSettingsOpen = false;
      this.isMenuManagerOpen = false;
      const wasOpen = this.isMarketingOpen;
      this.isMarketingOpen = !this.isMarketingOpen;
      if (this.isMarketingOpen && !wasOpen) {
        this.marketingJustOpened = true;
        setTimeout(() => {
          this.marketingJustOpened = false;
        }, 500);
        this.$nextTick(() => {
          this.scrollToSubmenu("Marketing");
        });
      } else if (wasOpen && !this.isMarketingOpen) {
        this.resetAsideScrollAfterCollapse();
      }
    },
    // Admin Settings submenu handlers
    toggleAdminSettings(event) {
      // Prevent event bubbling
      if (event) {
        event.stopPropagation();
      }
      
      // Clear any pending close timeouts
      if (this.adminSettingsTimeout) {
        clearTimeout(this.adminSettingsTimeout);
        this.adminSettingsTimeout = null;
      }
      
      // Close other submenus first
      this.isBusinessSettingsOpen = false;
      this.isSystemSettingsOpen = false;
      this.isMenuManagerOpen = false;
      this.isMarketingOpen = false;
      
      // Toggle this submenu
      const wasOpen = this.isAdminSettingsOpen;
      this.isAdminSettingsOpen = !this.isAdminSettingsOpen;
      
      // If opening, set flag to prevent immediate close
      if (this.isAdminSettingsOpen && !wasOpen) {
        this.adminSettingsJustOpened = true;
        setTimeout(() => {
          this.adminSettingsJustOpened = false;
        }, 500);
        
        this.$nextTick(() => {
          this.scrollToSubmenu('Settings');
        });
      } else if (wasOpen && !this.isAdminSettingsOpen) {
        this.resetAsideScrollAfterCollapse();
      }
    },
    openAdminSettings() {
      if (this.adminSettingsTimeout) {
        clearTimeout(this.adminSettingsTimeout);
        this.adminSettingsTimeout = null;
      }
      this.isAdminSettingsOpen = true;
    },
    closeAdminSettingsDelayed() {
      // Don't close if it was just opened
      if (this.adminSettingsJustOpened) {
        return;
      }
      
      this.adminSettingsTimeout = setTimeout(() => {
        // Double check it wasn't opened during the timeout
        if (!this.adminSettingsJustOpened) {
          this.isAdminSettingsOpen = false;
        }
      }, 500); // Reduced delay
    },
    checkStaffStatus() {
      // Check session storage for staff status
      const isStaff = authGet('is_staff');
      this.isStaff = isStaff === '1';
      if (this.isStaff) {
        try {
          const staffData = sessionStorage.getItem('staff');
          if (staffData) {
            this.staffInfo = JSON.parse(staffData);
          }
        } catch (e) {
          console.error('Error parsing staff data:', e);
        }
      }

      // Check session storage for agent status
      const isAgent = authGet('is_agent');
      this.isAgent = isAgent === '1';
      if (this.isAgent) {
        try {
          const agentData = sessionStorage.getItem('agent');
          if (agentData) {
            this.agentInfo = JSON.parse(agentData);
          }
        } catch (e) {
          console.error('Error parsing agent data:', e);
        }
      }

      // Also check from store state if available
      if (this.$store.state.auth.user && this.$store.state.auth.user.user_type === 'AGENT') {
        this.isAgent = true;
        this.agentInfo = this.$store.state.auth.user;
      }

      // Final check - if we're still not sure, check session storage again
      if (!this.isAgent && authGet('is_agent') === '1') {
        this.isAgent = true;
      }
    },
    hasPermission(permissionName) {
      // If not staff and not agent, always return true (admin users)
      if (!this.isStaff && !this.isAgent) {
        return true;
      }

      try {
        // Get staff permissions from session storage
        if (this.isStaff) {
          const permissionsJson = authGet('staff_permissions');
          if (!permissionsJson) return false;

          const permissions = JSON.parse(permissionsJson);
          return permissions.some(perm => perm.name === permissionName);
        }

        // Get agent permissions from session storage
        if (this.isAgent) {
          const permissionsJson = authGet('agent_permissions');
          if (!permissionsJson) return false;

          const permissions = JSON.parse(permissionsJson);
          return permissions.some(perm => perm.name === permissionName);
        }

        return false;
      } catch (e) {
        console.error('Error checking permissions:', e);
        return false;
      }
    },
    makeToast(variant, message) {
      this.$bvToast.toast(message, {
        title: "Message",
        variant: variant,
        solid: true
      });
    },
    scrollToBottom(delay = 300) {
      const scrollbar = document.getElementById('kt_aside_menu_scroll');

      if (scrollbar) {
        setTimeout(() => {
          scrollbar.scrollTop = scrollbar.scrollHeight;
        }, delay);
      } else {
        console.error('Perfect scrollbar element not found!');
      }
    },
    /** First direct child <a> toggle label for a `.menu-item-submenu` row (avoids :scope / nested labels). */
    getSubmenuToggleLabel(menuItem) {
      const children = menuItem.children;
      for (let i = 0; i < children.length; i++) {
        const node = children[i];
        if (node.tagName === 'A') {
          const textEl = node.querySelector('.menu-text');
          return textEl ? textEl.textContent.trim() : '';
        }
      }
      return '';
    },
    getAsideMenuScrollEl() {
      return (
        document.getElementById('kt_aside_menu_scroll') ||
        document.querySelector('#kt_aside_menu .aside-menu.scroll') ||
        document.querySelector('.aside-menu.scroll')
      );
    },
    resetAsideScrollAfterCollapse() {
      const scrollbar = this.getAsideMenuScrollEl();
      if (!scrollbar) return;

      const run = () => {
        try {
          const psVue = scrollbar.__vue__;
          if (psVue && typeof psVue.update === "function") {
            psVue.update();
          }
          scrollbar.scrollTop = 0;
        } catch (e) {
          scrollbar.scrollTop = 0;
        }
      };

      this.$nextTick(() => {
        requestAnimationFrame(run);
        setTimeout(run, 50);
        setTimeout(run, 340);
        setTimeout(run, 520);
      });
    },
    nudgeAsideForExpandedSubmenu(targetMenuItem) {
      const scrollbar = this.getAsideMenuScrollEl();
      if (!targetMenuItem || !scrollbar) return;

      try {
        const psVue = scrollbar.__vue__;
        if (psVue && typeof psVue.update === 'function') {
          psVue.update();
        }

        const pad = 28;
        const submenu = targetMenuItem.querySelector('.menu-submenu');
        const sr = scrollbar.getBoundingClientRect();
        const itemR = targetMenuItem.getBoundingClientRect();
        const subR = submenu ? submenu.getBoundingClientRect() : itemR;
        const blockTop = Math.min(itemR.top, subR.top);
        const blockBottom = Math.max(itemR.bottom, subR.bottom);
        const viewH = scrollbar.clientHeight;
        const maxScroll = Math.max(0, scrollbar.scrollHeight - viewH);

        const cTop = scrollbar.scrollTop + (blockTop - sr.top);
        const cBottom = scrollbar.scrollTop + (blockBottom - sr.top);
        const blockH = cBottom - cTop;

        let st = scrollbar.scrollTop;
        if (blockH > viewH - 2 * pad) {
          st = cTop - pad;
        } else {
          if (cBottom > st + viewH - pad) {
            st = cBottom - viewH + pad;
          }
          if (cTop < st + pad) {
            st = cTop - pad;
          }
        }
        st = Math.max(0, Math.min(st, maxScroll));

        if (Math.abs(st - scrollbar.scrollTop) > 1) {
          scrollbar.scrollTop = st;
        }
        if (psVue && typeof psVue.update === 'function') {
          this.$nextTick(() => psVue.update());
        }
      } catch (error) {
        console.error('Error scrolling to submenu:', error);
      }
    },
    scrollToSubmenu(menuText) {
      const menuItems = document.querySelectorAll('.menu-item-submenu');
      let targetMenuItem = null;

      menuItems.forEach(item => {
        if (this.getSubmenuToggleLabel(item) === menuText) {
          targetMenuItem = item;
        }
      });

      if (!targetMenuItem || !this.getAsideMenuScrollEl()) return;

      const inner = targetMenuItem.querySelector('.enhanced-submenu');
      const run = () => this.nudgeAsideForExpandedSubmenu(targetMenuItem);

      const onTransitionEnd = (e) => {
        if (e.target !== inner) return;
        if (e.propertyName !== 'max-height' && e.propertyName !== 'opacity') return;
        inner.removeEventListener('transitionend', onTransitionEnd);
        requestAnimationFrame(run);
      };

      this.$nextTick(() => {
        requestAnimationFrame(() => {
          run();
          setTimeout(run, 50);
          setTimeout(run, 340);
          setTimeout(run, 520);
        });
      });

      if (inner) {
        inner.addEventListener('transitionend', onTransitionEnd);
        setTimeout(() => inner.removeEventListener('transitionend', onTransitionEnd), 700);
      }
    },

    hasActiveChildren(match) {
      return this.$route["path"].indexOf(match) !== -1;
    },
    handleClickOutside(event) {
      // Check if click is outside all submenu items
      const clickedElement = event.target;
      const isClickOnSubmenu = clickedElement.closest('.menu-item-submenu');
      const isClickOnSubmenuContent = clickedElement.closest('.menu-submenu');
      
      // If click is outside submenus, close all submenus
      if (!isClickOnSubmenu && !isClickOnSubmenuContent) {
        // Small delay to allow toggle clicks to process first
        setTimeout(() => {
          if (!this.businessSettingsJustOpened && !this.systemSettingsJustOpened && !this.adminSettingsJustOpened && !this.menuManagerJustOpened && !this.marketingJustOpened) {
            this.isBusinessSettingsOpen = false;
            this.isSystemSettingsOpen = false;
            this.isAdminSettingsOpen = false;
            if (!this.hasActiveChildren("/menu-manager")) {
              this.isMenuManagerOpen = false;
            }
            if (!this.hasActiveChildren("/marketing")) {
              this.isMarketingOpen = false;
            }
            this.resetAsideScrollAfterCollapse();
          }
        }, 100);
      }
    },
  },
};
</script>
<style>
/* Sidebar visuals are owned by src/assets/css/tailwind.css — do not restyle #kt_aside here. */
.enhanced-menu-item.premium-menu-item {
  overflow: visible !important;
}

/* Premium Menu Item Styles */
.premium-menu-item.premium-disabled {
  opacity: 0.85;
  position: relative;
}

.premium-disabled-link {
  cursor: pointer !important;
  pointer-events: auto !important;
  position: relative;
  filter: none;
  display: flex !important;
  align-items: center !important;
  white-space: nowrap !important;
  flex-wrap: nowrap !important;
  overflow: visible !important;
  min-width: fit-content !important;
  gap: 12px !important;
}

.premium-menu-content {
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  gap: 6px !important;
  flex: 1 !important;
  min-width: 0 !important;
}

.premium-disabled-link .menu-icon {
  margin-top: 0 !important;
  flex-shrink: 0 !important;
  align-self: center !important;
}

.premium-disabled-link:hover {
  background: #eef0ff !important;
  color: #16124a !important;
  transform: none !important;
}

.premium-disabled-link .menu-text {
  text-decoration: none !important;
  color: #64748b !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 6px !important;
  line-height: 1.2 !important;
  margin: 0 !important;
  padding: 0 !important;
}

/* Lock icon after locked module labels */
.premium-disabled-link .menu-text::after {
  content: "\F341"; /* mdi-lock-outline */
  font-family: "Material Design Icons";
  font-size: 14px;
  line-height: 1;
  color: #c4a574;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 2px;
}

.premium-disabled-link .menu-icon {
  color: #94a3b8 !important;
}

.premium-badge,
.premium-disabled-link .premium-badge,
.enhanced-submenu-link .premium-badge,
.menu-link .premium-badge,
.menu-item .premium-badge,
.premium-menu-content .premium-badge,
.premium-disabled-link span.premium-badge,
.enhanced-submenu-link span.premium-badge,
.menu-link span.premium-badge,
.menu-item span.premium-badge {
  display: inline-block !important;
  margin-left: 0 !important;
  margin-top: 4px !important;
  padding: 3px 6px !important;
  background-color: #4a5568 !important;
  background: #4a5568 !important;
  color: #ffffff !important;
  border-radius: 10px !important;
  font-size: 8px !important;
  font-weight: 800 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.3px !important;
  white-space: nowrap !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.4) !important;
  line-height: 1.3 !important;
  opacity: 1 !important;
  position: relative !important;
  z-index: 10 !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5) !important;
  -webkit-font-smoothing: antialiased !important;
  -moz-osx-font-smoothing: grayscale !important;
  flex-shrink: 0 !important;
  overflow: visible !important;
  align-self: flex-start !important;
}

/* Force white text color for premium badge - highest specificity */
.premium-badge,
.premium-badge *,
.premium-disabled-link .premium-badge,
.premium-disabled-link .premium-badge *,
.enhanced-submenu-link .premium-badge,
.enhanced-submenu-link .premium-badge *,
.menu-link .premium-badge,
.menu-link .premium-badge *,
.menu-item .premium-badge,
.menu-item .premium-badge *,
span.premium-badge,
.premium-disabled-link span.premium-badge,
.enhanced-submenu-link span.premium-badge,
a .premium-badge,
a.premium-disabled-link .premium-badge {
  color: #ffffff !important;
  background-color: #4a5568 !important;
  background: #4a5568 !important;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

.tooltip.gmf-upgrade-tooltip .tooltip-inner,
.gmf-upgrade-tooltip .tooltip-inner {
  background: #241B5A !important;
  color: #ffffff !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  line-height: 1.35 !important;
  padding: 8px 12px !important;
  border-radius: 8px !important;
  box-shadow: 0 8px 20px rgba(36, 27, 90, 0.28) !important;
}

.tooltip.gmf-upgrade-tooltip.bs-tooltip-right .arrow::before,
.tooltip.gmf-upgrade-tooltip.bs-tooltip-auto[x-placement^="right"] .arrow::before {
  border-right-color: #241B5A !important;
}

.tooltip.gmf-upgrade-tooltip.bs-tooltip-left .arrow::before,
.tooltip.gmf-upgrade-tooltip.bs-tooltip-auto[x-placement^="left"] .arrow::before {
  border-left-color: #241B5A !important;
}

.tooltip.gmf-upgrade-tooltip.bs-tooltip-top .arrow::before,
.tooltip.gmf-upgrade-tooltip.bs-tooltip-auto[x-placement^="top"] .arrow::before {
  border-top-color: #241B5A !important;
}

.tooltip.gmf-upgrade-tooltip.bs-tooltip-bottom .arrow::before,
.tooltip.gmf-upgrade-tooltip.bs-tooltip-auto[x-placement^="bottom"] .arrow::before {
  border-bottom-color: #241B5A !important;
}

</style>

<style src="@/assets/css/tailwind.css"></style>
